import React from "react";
import { Flex, FlexProps } from "@edricphan2022/uikit";

const LayoutFlex: React.FC<FlexProps> = ({ children, ...props }) => (
  <Flex alignItems="center" justifyContent="space-between" {...props}>
    {children}
  </Flex>
);

export default LayoutFlex;
